import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";


export async function siteScheduleExceptionAdd(body: any) {
    try {
        const response = await apiPost('core', `site-schedule-exception`, body);
        return response;
    } catch (e) { }
}

export async function siteScheduleExceptionUpdate(body: any, id: string) {
    try {
        const response = await apiPut('core', `site-schedule-exception/${id}`, body);
        return response;
    } catch (e) { }
}

export async function siteScheduleExceptionRemove(id: any) {
    try {
        return await apiDelete('core', `site-schedule-exception/${id}`);
    } catch (e) { }
}


